module.exports = __webpack_public_path__ + "images/zekur58db7aa6a6ef6daeaae8c64bde4b7b2f.png";